import React from "react";
import {
  PortalWrapper,
  PortalHeader,
  BrandSection,
  UserSection,
  LogoutButton,
  PortalMainContent,
} from "../PatientPortal.styles";

export default function PatientPortalLayout({ patientName, onLogout, children }) {
  return (
    <PortalWrapper>
      {/* 1. Header Navbar Superior (Adaptable PC / Tablet / Mobile) */}
      <PortalHeader>
        <BrandSection>
          <div className="brand-logo-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect x="2" y="6" width="24" height="19" rx="4" fill="#244B7A" />
              <path
                d="M10 6V4.5C10 3.67 10.67 3 11.5 3H16.5C17.33 3 18 3.67 18 4.5V6"
                stroke="#244B7A"
                strokeWidth="2"
                fill="none"
              />
              <path
                d="M14 10.5V20.5M9 15.5H19"
                stroke="#FFFFFF"
                strokeWidth="2.5"
                strokeLinecap="round"
              />
            </svg>
          </div>
          <div className="brand-title">
            <span className="desktop-title">
              APIM <span className="dot">·</span> Portal del Paciente
            </span>
            <span className="mobile-title">APIM Paciente</span>
          </div>
        </BrandSection>

        <UserSection>
          <div className="user-badge">
            <div className="avatar-icon-circle">
              <svg
                width="24"
                height="24"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="14" cy="14" r="13" stroke="#94A3B8" strokeWidth="1.5" fill="#F8FAFC" />
                <circle cx="14" cy="10.5" r="4" stroke="#475569" strokeWidth="1.5" />
                <path
                  d="M7.5 22.5C8.8 19 11.2 17.5 14 17.5C16.8 17.5 19.2 19 20.5 22.5"
                  stroke="#475569"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
              </svg>
            </div>
            <span className="name">{patientName || "PACIENTE"}</span>
          </div>

          <LogoutButton onClick={onLogout} title="Cerrar sesión">
            <span className="btn-text">Cerrar Sesión</span>
            <span className="btn-icon-only">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                <polyline points="16 17 21 12 16 7" />
                <line x1="21" y1="12" x2="9" y2="12" />
              </svg>
            </span>
          </LogoutButton>
        </UserSection>
      </PortalHeader>

      {/* 2. Contenedor Principal Centrado */}
      <PortalMainContent>{children}</PortalMainContent>
    </PortalWrapper>
  );
}
